import { BookOpen, ArrowLeft } from '@phosphor-icons/react'
import { useNavigate } from 'react-router-dom'

export function PrivacyPolicy() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground text-sm mb-8 transition-colors"
        >
          <ArrowLeft size={16} />
          Voltar
        </button>

        <div className="flex items-center gap-3 mb-8">
          <BookOpen size={28} className="text-action-primary" />
          <h1 className="text-3xl font-black uppercase italic tracking-tight text-foreground">EDURPG.IA</h1>
        </div>

        <h2 className="text-2xl font-black text-foreground mb-2">Política de Privacidade</h2>
        <p className="text-muted-foreground text-sm mb-8">Última atualização: março de 2026</p>

        <div className="prose prose-sm max-w-none space-y-space-6 text-foreground">

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">1. Introdução</h3>
            <p className="text-muted-foreground leading-relaxed">
              O EDURPG.IA ("nós", "nosso" ou "plataforma") é uma plataforma educacional de RPG de mesa desenvolvida
              para ambientes de ensino. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos
              e protegemos seus dados pessoais ao utilizar nossos serviços em{' '}
              <a href="https://edurpg.ia.br" className="text-action-primary hover:underline">
                edurpg.ia.br
              </a>.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">2. Dados que Coletamos</h3>
            <p className="text-muted-foreground leading-relaxed">Podemos coletar as seguintes informações:</p>
            <ul className="list-disc pl-6 space-y-space-2 text-muted-foreground">
              <li><strong className="text-foreground">Dados de conta:</strong> nome, endereço de e-mail, nome de usuário e função (professor ou estudante).</li>
              <li><strong className="text-foreground">Login social:</strong> ao usar "Entrar com Google", recebemos seu nome, e-mail e foto de perfil públicos fornecidos pelo Google.</li>
              <li><strong className="text-foreground">Conteúdo gerado:</strong> personagens, mensagens de chat, rolagens de dados e configurações de campanhas criadas na plataforma.</li>
              <li><strong className="text-foreground">Dados técnicos:</strong> endereço IP, tipo de navegador e registros de acesso, coletados automaticamente para segurança e diagnóstico.</li>
            </ul>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">3. Como Usamos seus Dados</h3>
            <ul className="list-disc pl-6 space-y-space-2 text-muted-foreground">
              <li>Autenticar e gerenciar sua conta.</li>
              <li>Fornecer as funcionalidades da plataforma (mesas, personagens, módulos de jogo).</li>
              <li>Enviar comunicações relacionadas ao serviço (recuperação de senha, notificações).</li>
              <li>Melhorar e manter a segurança da plataforma.</li>
              <li>Cumprir obrigações legais aplicáveis.</li>
            </ul>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">4. Compartilhamento de Dados</h3>
            <p className="text-muted-foreground leading-relaxed">
              Não vendemos, alugamos nem compartilhamos seus dados pessoais com terceiros para fins comerciais.
              Dados podem ser compartilhados apenas quando necessário para operar o serviço (ex.: provedor de
              hospedagem) ou quando exigido por lei.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">5. Login com Google</h3>
            <p className="text-muted-foreground leading-relaxed">
              Ao autenticar via Google OAuth 2.0, recebemos somente as informações que você autoriza
              explicitamente (nome, e-mail e foto de perfil). Não acedemos a outros dados da sua conta Google.
              Você pode revogar esse acesso a qualquer momento em{' '}
              <a
                href="https://myaccount.google.com/permissions"
                target="_blank"
                rel="noopener noreferrer"
                className="text-action-primary hover:underline"
              >
                myaccount.google.com/permissions
              </a>.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">6. Retenção de Dados</h3>
            <p className="text-muted-foreground leading-relaxed">
              Seus dados são mantidos enquanto sua conta estiver ativa. Ao solicitar a exclusão da conta,
              seus dados pessoais serão removidos em até 30 dias, salvo obrigações legais de retenção.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">7. Segurança</h3>
            <p className="text-muted-foreground leading-relaxed">
              Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo comunicação
              criptografada via HTTPS, armazenamento seguro de senhas (bcrypt) e autenticação via tokens JWT.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">8. Seus Direitos</h3>
            <p className="text-muted-foreground leading-relaxed">
              Em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018), você tem
              direito a acessar, corrigir, exportar ou solicitar a exclusão de seus dados pessoais.
              Entre em contato conosco pelo e-mail abaixo.
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">9. Contato</h3>
            <p className="text-muted-foreground leading-relaxed">
              Para dúvidas, solicitações ou exercício de direitos relacionados a esta política, entre em contato:
              <br />
              <strong className="text-foreground">E-mail:</strong>{' '}
              <a href="mailto:paulovicente.ifba@gmail.com" className="text-action-primary hover:underline">
                paulovicente.ifba@gmail.com
              </a>
            </p>
          </section>

          <section className="space-y-space-3">
            <h3 className="text-lg font-bold text-foreground">10. Alterações nesta Política</h3>
            <p className="text-muted-foreground leading-relaxed">
              Podemos atualizar esta política periodicamente. Notificaremos usuários sobre mudanças relevantes
              por e-mail ou mediante aviso na plataforma. O uso continuado do serviço após as alterações
              constitui aceitação da nova política.
            </p>
          </section>

        </div>

        <p className="mt-10 text-xs text-muted-foreground text-center">
          © {new Date().getFullYear()} EDURPG.IA · Plataforma Educacional de RPG de Mesa
        </p>
      </div>
    </div>
  )
}
